import React from 'react';
import { Routes, Route } from 'react-router';
import MainLayout from './components/layout/MainLayout';
import Users from './pages/admin/Users';
import Products from './pages/Products';
import Dashboard from './pages/Dashboard';
import SignIn from './pages/SignIn';
import SignOut from './pages/SignOut';
import TestPage from './pages/TestPage';
import Profile from './pages/Profile';
import Materials from './pages/Materials';
// import { useClient } from './graphql/hooks';

function App() {
  // const client = useClient();
  // const [wipe, setWipe] = React.useState(0);
  // React.useEffect(() => {
  //   console.log('calling resetStore');
  //   client.resetStore();
  // }, [wipe]);
  // React.useEffect(() => {
  // window.setInterval(() => {
  //   console.log('Interval Resett');
  //   // client.resetStore();
  //   setWipe(new Date().getTime());
  // }, 5000);
  // }, []);
  return (
    <Routes>
      <Route path="/" element={<MainLayout login_required />}>
        {/* renders into the outlet in <Root> at "/" */}
        <Route index element={<Dashboard />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:product_id" element={<Products />} />
        <Route path="products/:product_id/:qc_id" element={<Products />} />
        <Route path="users" element={<Users />} />
        <Route path="test" element={<TestPage />} />
        <Route path="profile" element={<Profile />} />
        <Route path="materials" element={<Materials />} />

        {/* <Route path="dashboard" element={<Dashboard />}> */}
        {/* renders into the outlet in <Dashboard> at "/dashboard" */}
        {/*<Route index element={<DashboardHome />} />
            <Route path="settings" element={<Settings />} />
          </Route> */}
      </Route>
      <Route path="/auth" element={<MainLayout />}>
        <Route index element={<SignIn />} />
        <Route path="logout" element={<SignOut />} />
      </Route>
    </Routes>
  );
}

export default App;
